"use strict";

var _interopRequireDefault = require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.modelGet = modelGet;
exports.modelSet = modelSet;
exports.modelSetWithServer = modelSetWithServer;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.constructor");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _vue = _interopRequireDefault(require("vue"));
var _vuex = _interopRequireDefault(require("vuex"));
var _getters = _interopRequireDefault(require("./getters"));
var _modelSetWithServer;
_vue.default.use(_vuex.default);
var modulesFiles = require.context('./modules', true, /\.js$/);
var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
  // set './app.js' => 'app'
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  var value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
var mutations = {
  modelSet: function modelSet(state, payload) {
    _.set(state, payload.path, payload.data);
  }
};
var store = new _vuex.default.Store({
  modules: modules,
  getters: _getters.default,
  mutations: mutations
});
var _default = store;
exports.default = _default;
function modelSet(p0, p1, p2) {
  if (arguments.length === 2) {
    var path = p0;
    var data = p1;
    store.commit("modelSet", {
      path: path,
      data: data
    });
  } else if (arguments.length === 3) {
    var moduleName = p0;
    var _path = p1;
    var _data = p2;
    store.commit("".concat(moduleName, "/modelSet"), {
      path: _path,
      data: _data
    });
  }
}
function modelGet(p0, p1) {
  if (arguments.length === 1) {
    var path = p0;
    return _.get(store.state, path);
  } else if (arguments.length === 2) {
    var moduleName = p0;
    var _path2 = p1;
    return _.get(store.state, "".concat(moduleName, ".").concat(_path2));
  }
}
function modelSetWithServer(_x, _x2, _x3) {
  return (_modelSetWithServer = _modelSetWithServer || (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(p0, p1, p2) {
    var moduleName, path, data, moduleNameArr, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          moduleName = p0;
          path = p1;
          data = p2;
          if (new RegExp('.').test(p0)) {
            moduleNameArr = p0.split('.');
            moduleName = moduleNameArr.shift();
            path = moduleNameArr.join('.');
            data = p1;
          }
          _context.prev = 4;
          _context.next = 7;
          return store.dispatch("".concat(moduleName, "/modelSetWithServer"), {
            path: path,
            data: data
          });
        case 7:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](4);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 11]]);
  }))).apply(this, arguments);
}